import { ref } from 'vue'

// 当前激活的 kiosk group id
const currentKioskGroupId = ref<string | null>(null)

export function setCurrentKioskGroup(groupId: string | null) {
  currentKioskGroupId.value = groupId
}

export function getCurrentKioskGroup() {
  return currentKioskGroupId.value
}
